<template>
  <div>
    <div class="tile is-ancestor">
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import GridBox from '@/components/boxes/GridBox.vue'
import AlertBox from '@/components/boxes/AlertBox.vue'

export default {
  components: {
    GridBox,
    AlertBox
  },

  data () {
    return {
      loading: true,
      userSettings: null
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    ...mapGetters('auth', ['hasPermission'])
  },

  methods: {
    ...mapActions('userSettings', ['getCurrentUserSettings'])
  },

  created () {
    const promises = []
    promises.push(this.getCurrentUserSettings().then(userSettings => {
      this.userSettings = userSettings
    }))

    Promise.all(promises).then(() => {
      this.loading = false
    })
  }
}
</script>

<style lang="scss" scoped>
  .is-loading {
    height: 10rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/StaffViews/DefaultDashboard.vue